// test60
(60 && 0);
